import React from 'react';
import castArray from 'lodash/castArray';
import clsx from 'clsx';

type Props = {
  children: any;
  position?: string;
  classList?: Array<any | false>;
  style?: any;
  onClick?: any;
};

const PreKittMessageFrame = ({
  children,
  position = 'absolute',
  classList = [],
  ...props
}: Props) => (
  <div
    className={clsx(...castArray(classList))}
    style={{
      position,
      zIndex: 10,
      display: 'inline-block',
      backgroundColor: 'white',
      border: '5px solid black',
      borderRadius: '100px 8px 225px 5px/8px 225px 5px 255px',
      boxShadow: '0 4px 20px 5px rgba(55, 55, 55, .5)',
      userSelect: 'none'
    }}
    {...props}
  >
    {children}
  </div>
);

export default PreKittMessageFrame;
